<div class="container-fluid">
  <app-content-tab-list activeTab="1" type="communication" category="communication"></app-content-tab-list>

  <div class="row section1 mt-4 align-items-center">
    <div class="col-12 col-md-7 col-lg-7 col-xl-7">
      <div class="home-details">
        <h5 class="home-title">Suggestions</h5>
        <p class="home-subtitle">List of all Suggestions</p>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-5 col-xl-5">
      <div class="dashboard-btn dashboard-manage">
      </div>
    </div>
  </div>
  <!-----------user table------------------>
  <div class="row section1 ">
    <div class="col-12">
      <div class="table-responsive applicants-details overflow-x-visible">
        <table class="table table-bordered user-table">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">E-mail</th>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">Message</th>
              <th scope="col">Request Type</th>
              <th scope="col">Created At</th>
            </tr>
          </thead>
          @if (!loading && !!suggestions?.length) {
            <tbody>
              @for (suggestion of suggestions; track suggestion; let i = $index) {
                <tr class="client">
                  <td>{{ suggestion.id }}</td>
                  <td class="email-display">{{ suggestion.email | lowercaseEmail }}</td>
                  <td>{{suggestion.firstName}}</td>
                  <td>{{suggestion.lastName}}</td>
                  <td>{{ suggestion.message }}</td>
                  <td>{{ suggestion.request_type }}</td>
                  <td>{{ suggestion.createdAt | date:'medium' }}</td>
                </tr>
              }
            </tbody>
          }
          @if (loading) {
            <tbody>
              @for (q of loaders; track q; let qi = $index) {
                <tr class="client">
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'150px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{ width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
        @if (!loading && !suggestions?.length) {
          <div class="d-flex align-items-center justify-content-center py-5">
            No suggestions found
          </div>
        }
      </div>
    </div>
  </div>
</div>
